import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var Property =
/*#__PURE__*/
function () {
  function Property() {
    _classCallCheck(this, Property);
  }

  _createClass(Property, [{
    key: "GetOccupancyReport",
    value: function () {
      var _GetOccupancyReport = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(propertyId, numberOfMonths) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/GetOccupancyReport/".concat(propertyId, "/").concat(numberOfMonths)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetOccupancyReport(_x, _x2) {
        return _GetOccupancyReport.apply(this, arguments);
      }

      return GetOccupancyReport;
    }()
  }, {
    key: "GetHistoricalProjectId",
    value: function () {
      var _GetHistoricalProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(propertyId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/Projects/GetHistoricalProjectId/".concat(propertyId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetHistoricalProjectId(_x3) {
        return _GetHistoricalProjectId.apply(this, arguments);
      }

      return GetHistoricalProjectId;
    }()
  }]);

  return Property;
}();

export default new Property();